// src/services/bitacoraService.js
import { apiClient } from './api';

const bitacoraService = {
  listar: (params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') query.append(k, v);
    });
    return apiClient.get(`/bitacora/?${query.toString()}`);
  },

  listarEntidades: () => apiClient.get('/bitacora/entidades'),

  listarAcciones: () => apiClient.get('/bitacora/acciones'),
};

export default bitacoraService;
